import { render, staticRenderFns } from "./SkillSimView.vue?vue&type=template&id=7c36771c&"
import script from "./SkillSimView.vue?vue&type=script&lang=ts&"
export * from "./SkillSimView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports